import * as React from 'react';

export const FlexibleSpace = () => <div className="d-flex ml-auto" />;
